// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host{width:400px;height:400px;flex:1;display:flex}:host .dialog-content-align-middle{padding:0 20px}:host .dialog-title{font-weight:normal;text-align:center;margin:20px 0;padding:0 60px}`, "",{"version":3,"sources":["webpack://./packages/theme/styles/_settings.scss","webpack://./packages/builder-sales/leads/components/lead-details/lead-details-reassign-dialog/lead-details-reassign-dialog.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CCUC,MACE,WAAA,CACA,YAAA,CACA,MAAA,CACA,YAAA,CAEA,mCACE,cAAA,CAGF,oBACE,kBAAA,CACA,iBAAA,CACA,aAAA,CACA,cAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@forward \"settings/colors\";\n@forward \"settings/variables\";"," /*\n\n Developed for G.J. Gardner Homes by Softeq Development Corporation\n http://www.softeq.com\n\n */\n\n @use \"theme/styles/settings\" as *;\n @use \"theme/styles/tools\" as *;\n\n :host {\n   width: 400px;\n   height: 400px;\n   flex: 1;\n   display: flex;\n\n   .dialog-content-align-middle {\n     padding: 0 20px;\n   }\n\n   .dialog-title {\n     font-weight: normal;\n     text-align: center;\n     margin: 20px 0;\n     padding: 0 60px;\n   }\n }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
